"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformCreateSsoUserResponseApiDtoToDomain = exports.transformCreateSsoUserResponseDataApiDomainToDto = exports.transformCreateSsoUserRequestApiDtoToDomain = exports.transformCreateSsoUserRequestApiDomainToDto = void 0;
const class_transformer_1 = require("class-transformer");
const create_sso_user_api_domain_1 = require("../create-sso-user-api-domain");
// =============================================================================
// Request
// =============================================================================
function transformCreateSsoUserRequestApiDomainToDto(domain) {
    return (0, class_transformer_1.instanceToPlain)(domain);
}
exports.transformCreateSsoUserRequestApiDomainToDto = transformCreateSsoUserRequestApiDomainToDto;
function transformCreateSsoUserRequestApiDtoToDomain(dto) {
    return (0, class_transformer_1.plainToInstance)(create_sso_user_api_domain_1.CreateSsoUserRequestBodyApiDomain, dto);
}
exports.transformCreateSsoUserRequestApiDtoToDomain = transformCreateSsoUserRequestApiDtoToDomain;
// =============================================================================
// Response
// =============================================================================
function transformCreateSsoUserResponseDataApiDomainToDto(domain) {
    return (0, class_transformer_1.instanceToPlain)(domain);
}
exports.transformCreateSsoUserResponseDataApiDomainToDto = transformCreateSsoUserResponseDataApiDomainToDto;
function transformCreateSsoUserResponseApiDtoToDomain(dto) {
    return (0, class_transformer_1.plainToInstance)(create_sso_user_api_domain_1.CreateSsoUserResponseBodyApiDomain, dto);
}
exports.transformCreateSsoUserResponseApiDtoToDomain = transformCreateSsoUserResponseApiDtoToDomain;
//# sourceMappingURL=create-sso-user-api-domain-transformer.js.map